import { render, staticRenderFns } from "./CenterViewPreview3dPlate_Ap.vue?vue&type=template&id=0f4c6b65&scoped=true"
import script from "./CenterViewPreview3dPlate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewPreview3dPlate_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewPreview3dPlate_Ap.vue?vue&type=style&index=0&id=0f4c6b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c6b65",
  null
  
)

export default component.exports